import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { OrganizationKeyName } from "../../model/Organization";
import { OrganizationUISettings } from "../../model/OrganizationUISettings";
import { RootState } from "../../store";
import { OrganizationSettingsUpsertForm } from "./OrganizationSettingsUpsertForm";
import { PageHeader } from "../common/PageHeader";
import * as organizationSelectors from "./organizationSelectors";
import * as organizationActions from "./organizationActions";
import * as authSelectors from "./../auth/authSelectors";
import { withTranslation } from "react-i18next";

interface OwnProps {}

interface Props extends OwnProps {
  organization: OrganizationKeyName | undefined;
  uiSettings: OrganizationUISettings | undefined;
  saveUISettings: (
    org: OrganizationKeyName,
    data: OrganizationUISettings
  ) => void;
}

interface State {}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  return {
    organization: authSelectors.selectedOrganizationKeyName(state),
    uiSettings: organizationSelectors.currentUISettings(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    saveUISettings: (
      org: OrganizationKeyName,
      data: OrganizationUISettings
    ) => {
      dispatch(organizationActions.upsertUISettings(org, data));
    },
  };
};

export class OrganizationSettingsUpsert extends React.Component<Props, State> {
  onSubmit = (values: any) => {
    const org = this.props.organization;
    if (!org) {
      throw new Error("No organization");
    }
    this.props.saveUISettings(org, values);
  };

  render() {
    const uiSettings = this.props.uiSettings;
    if (!uiSettings) {
      return null;
    }

    return (
      <div className="container">
        <PageHeader
          title="Organization UI Settings Edit"
          breadcrumbs={[
            { title: "Organization" },
            { title: "Edit UI Settings", isActive: true },
          ]}
        />

        <div className="row">
          <div className="col-12">
            <OrganizationSettingsUpsertForm
              onSubmit={this.onSubmit}
              uiSettings={uiSettings}
              isUpsertingUISettings={false}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(OrganizationSettingsUpsert));
